import React, { Fragment } from 'react';

import { css } from '@emotion/css';
import { Transition } from '@headlessui/react';
import { observer } from 'mobx-react-lite';

import { MobxInputValue } from '^/util/MobxInputValue';

import { ConfirmDialogDefaultStyles, ConfirmDialogStyles } from './ConfirmDialogPopup.styles';

export const ConfirmDialogPopupDesktop: React.FC<{
  title: React.ReactNode;
  visible: MobxInputValue<boolean>;
  cancelText: string;
  confirmText: string;
  isDisabled?: boolean;
  handleConfirm(e: React.MouseEvent): void;
  handleCancel(e: React.MouseEvent): void;
  stylesOverrides?: Partial<ConfirmDialogStyles>;
}> = observer(function ConfirmDialogPopupDesktop({
  title,
  visible,
  cancelText,
  confirmText,
  isDisabled,
  handleCancel,
  handleConfirm,
  stylesOverrides,
}) {
  const styles = {
    ...ConfirmDialogDefaultStyles,
    ...stylesOverrides,
  };
  return (
    <Transition appear show={visible.value} as={Fragment}>
      <div className="z-[50] grid place-items-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.modalBackground} />
        </Transition.Child>

        <div className="fixed inset-0">
          <div
            className={[
              'flex justify-center items-center tablet:px-6 tablet-max:px-4 mb-12 text-center relative',
              css`
                height: 100vh;
                overscroll-behavior: contain;
                overflow: hidden;
              `,
            ].join(' ')}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={[
                  'transform relative overflow-y-auto rounded-trimo bg-white tablet:px-6 tablet-max:px-4 text-left align-middle shadow-xl transition-all tablet:py-6',
                  // borders.DEBUG_greenBorderDashed,
                  styles.modalRoot,
                ].join(' ')}
              >
                {title}
                <div className={[styles.buttonGroup].join(' ')}>
                  <button
                    type="button"
                    className={[styles.button, styles.buttonCancel].join(' ')}
                    onClick={(e) => {
                      visible.set(false);
                      handleCancel(e);
                    }}
                  >
                    {cancelText}
                  </button>
                  <button
                    type="button"
                    disabled={isDisabled}
                    className={[styles.button, styles.buttonConfirm].join(' ')}
                    onClick={(e) => {
                      visible.set(false);
                      handleConfirm(e);
                    }}
                  >
                    {confirmText}
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </div>
    </Transition>
  );
});
